// extracted by mini-css-extract-plugin
export default {"main":"styles_main__5Hm4k","myVideo":"styles_myVideo__Bb-OJ","title":"styles_title__L+cU8"};